import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

function Favorite() {
  const [favorite, setFavorite] = useState([]);
  const [incarca, setIncarca] = useState(true);
  const navigate = useNavigate();

  const taburi = [
    { nume: 'Gestioneaza anunturile', link: '/anunturile-mele', activ: false },
    { nume: 'Comenzile mele', link: '/comenzi', activ: false },
    { nume: 'Mesaje', link: '/mesaje', activ: false },
    { nume: 'Favorite', link: '/favorite', activ: true },
    { nume: 'Alertele mele', link: '/alerte', activ: false },
    { nume: 'Detaliile mele', link: '/setari', activ: false }
  ];

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/');
      return;
    }
    incarcaFavorite(token);
  }, [navigate]);

  const incarcaFavorite = async (token) => {
    try {
      const raspuns = await fetch('https://tranzitio.onrender.com/api/favorite/mele', {
        headers: { 'x-auth-token': token }
      });
      if (raspuns.ok) {
        const date = await raspuns.json();
        setFavorite(date);
      } else {
        toast.error('Eroare la preluarea favoritelor');
      }
    } catch (eroare) {
      toast.error('Eroare de conexiune');
    } finally {
      setIncarca(false);
    }
  };

  const eliminaFavorit = async (idAnunt) => {
    try {
      const token = localStorage.getItem('token');
      const raspuns = await fetch(`https://tranzitio.onrender.com/api/favorite/${idAnunt}`, {
        method: 'POST',
        headers: {
          'x-auth-token': token
        }
      });

      if (raspuns.ok) {
        toast.success('Anunt eliminat din favorite');
        incarcaFavorite(token);
      } else {
        toast.error('Eroare la eliminare');
      }
    } catch (eroare) {
      toast.error('Eroare de conexiune');
    }
  };

  if (incarca) {
    return <div className="text-center mt-20 font-bold text-xl text-gray-500">Se incarca...</div>;
  }

  return (
    <div className="min-h-screen bg-[#f3f4f6]">
      <div className="bg-white border-b border-gray-200 overflow-x-auto">
        <div className="max-w-7xl mx-auto px-4 flex min-w-max">
          {taburi.map((tab, index) => (
            <Link
              key={index}
              to={tab.link}
              className={`flex items-center gap-2 px-6 py-4 text-sm font-bold transition-all border-b-4 ${
                tab.activ 
                  ? 'border-blue-600 text-blue-700' 
                  : 'border-transparent text-gray-500 hover:text-gray-800 hover:bg-gray-50'
              }`}
            >
              {tab.nume}
            </Link>
          ))}
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-4 py-8">
        <h2 className="text-2xl font-black text-gray-800 mb-6">Anunturile tale favorite</h2>

        {favorite.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-24 bg-white rounded-xl shadow-sm border border-gray-100">
            <div className="w-20 h-20 bg-red-50 rounded-full flex items-center justify-center mb-6 text-red-500">
              <svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">Nu ai salvat niciun anunt</h3>
            <p className="text-gray-500 font-medium mb-6">Cand gasesti ceva care iti place, apasa pe inima pentru a-l pastra aici.</p>
            <Link 
              to="/" 
              className="bg-blue-600 text-white font-bold px-8 py-3 rounded-lg hover:bg-blue-700 transition"
            >
              Cauta anunturi
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {favorite.map((element) => {
              const anunt = element.anunt;
              if (!anunt) return null;

              let pozaAflisata = '';
              if (Array.isArray(anunt.imagini) && anunt.imagini.length > 0) {
                pozaAflisata = anunt.imagini[0];
              } else if (anunt.imagine) {
                pozaAflisata = anunt.imagine;
              }

              return (
                <div key={element._id} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden flex flex-col relative group">
                  <button 
                    onClick={() => eliminaFavorit(anunt._id)}
                    className="absolute top-3 right-3 z-10 w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-md text-red-500 hover:bg-red-50 transition"
                  >
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                    </svg>
                  </button>

                  <Link to={`/anunt/${anunt._id}`} className="block h-48 bg-gray-100 relative">
                    {pozaAflisata ? (
                      <img src={pozaAflisata} alt={anunt.titlu} className="w-full h-full object-cover" />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-gray-400 font-bold">Fara imagine</div>
                    )}
                  </Link>

                  <div className="p-4 flex flex-col flex-grow">
                    <Link to={`/anunt/${anunt._id}`}>
                      <h3 className="font-bold text-lg mb-2 line-clamp-2 text-gray-800 hover:text-blue-600 transition">{anunt.titlu}</h3>
                    </Link>
                    <p className="text-gray-500 text-sm mb-4">{anunt.localitate}</p>
                    <p className="text-blue-700 font-black text-xl mt-auto">{anunt.pret} {anunt.moneda || 'RON'}</p>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default Favorite;